import styled from "styled-components";

export const RouteListContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const Select = styled.button`
  position: relative;
  min-width: 45px;
  font-size: 18px;
  appearance: none;
  font-weight: bold;
  background: white;
  border-radius: 8px;
  padding: 4px 12px;
  border: none;
  text-align: right;
  border: 1px solid #e1e1e1;
  outline: none;
  position: relative;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-position: center left;
  background-repeat: no-repeat;
  padding-left: 25px;
`;

export const NamePart = styled.span`
  display: inline-block;
  font-weight: bold;
  position: relative;
  padding: 0 2px;
  & + & {
    margin-left: 14px;
  }
  & + &::after {
    content: " ";
    position: absolute;
    border-left: 1px solid #e1e5e9;
    left: -7px;
    top: -1px;
    bottom: -1px;
  }
`;

export const CategorySelectorContainer = styled.div`
  padding: 0 10px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const MapContainer = styled.div`
  max-height: 100vw;
`;
